export const tiandituConfig = {
    url: 'https://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&tk=da3ca529d1be04011d0c1acc73cddf39&',
};
//export const baseHost = 'http://192.168.0.12:9503/iirms';
export const baseHost = 'https://kcsk.hyicloud.com/iirms';
//export const fileHost = 'http://121.40.203.50:9012/iirms/private/';//生产-图片预览路径
export const fileHost = 'https://kcsk.hyicloud.com/iirms/private/';//生产-图片预览路径
